import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkOnboardingStage } from '../features/user/userSlice';
import OnboardingFormNew from './OnboardingFormNew';
import SubscriptionSelection from './SubscriptionSelection';
import WelcomeScreen from './WelcomeScreen';
import styles from '../styles/OnboardingFlow.module.css';

export default function OnboardingFlow() {
  const dispatch = useDispatch();
  const onboarding = useSelector(state => state.user.onboarding);
  const token = useSelector(state => state.user.token);
  const [loading, setLoading] = useState(true);
  const hasInitialized = useRef(false);

  const checkStage = () => {
    if (token) {
      console.log('OnboardingFlow: Re-checking onboarding stage...');
      setLoading(true);
      dispatch(checkOnboardingStage()).finally(() => {
        console.log('OnboardingFlow: Stage re-check completed');
        setLoading(false);
      });
    }
  };

  useEffect(() => {
    if (token && !hasInitialized.current) {
      console.log('OnboardingFlow: Component mounted, token:', token);
      hasInitialized.current = true;
      checkStage();
    } else if (onboarding.stage) {
      // If we already have a stage and it's welcome_screen, don't refetch
      setLoading(false);
    }
  }, [dispatch, token]);

  // Listen for stage changes and automatically re-check
  useEffect(() => {
    console.log('OnboardingFlow: Stage changed to:', onboarding.stage);
  }, [onboarding.stage]);

  if (loading || onboarding.loading) {
    console.log('OnboardingFlow: Loading state, loading:', loading, 'onboarding.loading:', onboarding.loading);
    return <div className={styles.loading}>Loading onboarding...</div>;
  }
  if (onboarding.error) {
    console.log('OnboardingFlow: Error state:', onboarding.error);
    return <div className={styles.error}>{onboarding.error}</div>;
  }

  console.log('OnboardingFlow: Rendering with stage:', onboarding.stage);

  return (
    <div className={styles.onboardingContainer}>
      {/* NEW API FORMAT: stage can be 'pending', 'draft', 'completed' */}
      {/* Use new multi-step form design */}
      {(onboarding.stage === 'pending' || onboarding.stage === 'draft') && (
        <OnboardingFormNew onFormSubmitted={checkStage} />
      )}
      {/* Keep subscription selection and welcome screen */}
      {onboarding.stage === 'subscription_selection' && (
        <SubscriptionSelection onSubscriptionComplete={checkStage} />
      )}
      {onboarding.stage === 'completed' && (
        <WelcomeScreen />
      )}
    </div>
  );
}
